export default "__VITE_ASSET__3dcc4228__"